import { styled, Theme } from '@mui/material';
import { themeDefaults } from '@youscience/theme';

import { ThemeOptions } from './StatisticsSection';

export const sxStyles = {
  title: (theme: Theme) => ({
    marginBottom: '2rem',
    marginTop: '2.75rem',
    color: theme.palette.primary.main,
  }),
  infoItemsWrap: (theme: Theme) => ({
    '> :not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  }),
  infoItemTitle: {
    fontWeight: 700,
  },
  awardUpToValue: {
    color: (themeDefaults as ThemeOptions).chartsColorPalette.indigo.main,
  },
  availableAwardsValue: {
    color: themeDefaults?.palette?.text?.disabled,
  },
};

export const StyledSectionsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: '1rem',
  },
}));

export const StyledChartSectionInner = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: '100%',
  padding: '1.5rem 2rem',
  boxShadow: '0px 5px 25px rgba(17, 77, 76, 0.1)',
  borderRadius: '0.5rem',

  '& > div:first-of-type': {
    marginTop: '1.5rem',
  },

  [theme.breakpoints.up('sm')]: {
    maxWidth: '432px',
  },

  [theme.breakpoints.up('md')]: {
    padding: '2rem 3.5rem',
  },
}));

export const StyledInfoSectionInner = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: '100%',
  padding: '1.5rem 2rem',
  boxShadow: '0px 5px 25px rgba(17, 77, 76, 0.1)',
  borderRadius: '0.5rem',

  [theme.breakpoints.up('md')]: {
    padding: '2rem 3.5rem 2.5rem',
  },
}));

export const StyledInfoItem = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '0.75rem 0',

  '& > div:first-of-type': {
    marginRight: '1rem',
  },
}));
